<header class="header-section">
  <!-- Background image (keep your original image) -->
  <div class="header-top">
    <img src="assets/header.png" alt="CSRGS Header" class="w-100 header-image" />
  </div>

  <!-- Navbar Section -->
  <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
    <div class="container-fluid" style="    padding: 5px 0px;
    background-color: #2f4f4f;">
      <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed"
        [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-center" [ngbCollapse]="isCollapsed">
        <ul class="navbar-nav d-flex flex-wrap gap-2">
          <li class="nav-item">
            <a routerLink="/home" routerLinkActive="active" class="nav-link">Home</a>
          </li>
          <li ngbDropdown class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" ngbDropdownToggle>About Us</a>
            <div ngbDropdownMenu class="dropdown-menu">
              <a ngbDropdownItem routerLink="/aboutus">About CSRGS</a>
              <a ngbDropdownItem routerLink="/csrgs-infrastructure">Infrastructure</a>
              <a ngbDropdownItem routerLink="/our-school-management">Management</a>
              <a ngbDropdownItem routerLink="/staff-information">Staff Information</a>
              <a ngbDropdownItem routerLink="/student-information">Students Information</a>
              <a ngbDropdownItem routerLink="/annual-calendar">Annual Calendar</a>
              <a ngbDropdownItem routerLink="/socialConnect">Social Connect</a>
              <a ngbDropdownItem routerLink="/youtube-channel">YouTube Channel</a>
            </div>
          </li>
          <li class="nav-item">
            <a routerLink="/admission" routerLinkActive="active" class="nav-link">Admission</a>
          </li>
          <li class="nav-item">
            <a routerLink="/mandatory-public-disclosure" routerLinkActive="active" class="nav-link">Mandatory
              Disclosure</a>
          </li>
          <li class="nav-item">
            <a routerLink="/school-information" routerLinkActive="active" class="nav-link">School Data</a>
          </li>
          <li class="nav-item">
            <a routerLink="/achievements" routerLinkActive="active" class="nav-link">Achievements</a>
          </li>
          <li class="nav-item">
            <a routerLink="/our-gallery" routerLinkActive="active" class="nav-link">Gallery</a>
          </li>
          <li class="nav-item">
            <a routerLink="/facilities" routerLinkActive="active" class="nav-link">Facilities</a>
          </li>
          <li class="nav-item">
            <a routerLink="/contact-us" routerLinkActive="active" class="nav-link">Contact Us</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>